<template>
    <v-data-table :headers="headers" :items="parts" :loading="table_loader" hide-actions>
        <template slot="items" slot-scope="props">
            <tr class="clickable" @mouseup.left="profile(props.item.part_id)">
                <td>{{ props.item.name }}</td>
                <td>{{ props.item.customer_part_number }}</td>
                <td>{{ props.item.in_production == "1" ? $t("lang.mass") : $t("lang.prototype") }}</td>
            </tr>
        </template>
        <template slot="no-data">
            <tr class="no-hover">
                <td class="w-100" :colspan="headers.length">
                    <v-layout>
                        <v-flex class="text-center align-content-center" :style="$bp.smallScreen ? 'margin-top:16px;' : 'height:calc(100vh - 300px)'">
                            <span class="blue-grey--text text--lighten-4 display-1">{{
                                table_loader ? $t("lang.loading") : $t("lang.no_parts_available")
                            }}</span>
                        </v-flex>
                    </v-layout>
                </td>
            </tr>
        </template>
    </v-data-table>
</template>

<script>
export default {
    name: "parts",
    data() {
        return {
            headers: [
                { text: this.$t("lang.name"), sortable: false },
                { text: this.$t("lang.customer_part_number"), sortable: false },
                { text: this.$t("lang.production"), sortable: false },
            ],
            parts: [],
            customer_id: null,
            settings: {
                maxScrollbarLength: 150,
            },
            table_loader: true,
        };
    },
    mounted: function () {
        this.customer_id = this.$route.params.id;
        this.getParts();
    },
    methods: {
        getParts() {
            this.$store
                .dispatch("fetchPart", {
                    url: "parts",
                    method: "get",
                    body: {
                        company_id: this.customer_id,
                    },
                })
                .then((data) => {
                    if (typeof data !== "undefined") this.parts = data.parts;
                })
                .finally(() => {
                    this.table_loader = false;
                });
        },
        profile(id) {
            this.$router.push({ name: "part_profile", params: { id: id } });
        },
    },
};
</script>
